import { CHAIN_ID } from "./constants";

export const getDefaultChainId = (supportedNetworks: any[]): number => {
  if (!supportedNetworks.length) return CHAIN_ID.LINEA_MAINNET;

  const lineaNetwork = supportedNetworks.find(
    (n: any) => n.chainId === CHAIN_ID.LINEA_MAINNET
  );
  if (lineaNetwork) return lineaNetwork.chainId;

  return supportedNetworks[0].chainId;
};
